module.exports = __webpack_public_path__ + "static/media/icon-down.714cf81c.svg";